var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCounterManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3029 24.45C24.8842 24.45 28.598 20.7675 28.598 16.225C28.598 11.6825 24.8842 8 20.3029 8C15.7217 8 12.0078 11.6825 12.0078 16.225C12.0078 20.7675 15.7217 24.45 20.3029 24.45Z",
    fill: "#CB2110"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3027 43C27.0972 43 32.6053 39.3176 32.6053 34.775C32.6053 30.2325 27.0972 26.55 20.3027 26.55C13.5081 26.55 8 30.2325 8 34.775C8 39.3176 13.5081 43 20.3027 43Z",
    fill: "#804419"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1836 11.4999C32.2208 11.501 31.2704 11.7162 30.401 12.1299C31.1345 13.9099 31.3722 15.8553 31.0887 17.7596C30.8052 19.6638 30.0112 21.4557 28.791 22.9449C29.5827 23.6657 30.5383 24.1825 31.5749 24.4504C32.6115 24.7183 33.6979 24.7292 34.7397 24.4822C35.7815 24.2351 36.7472 23.7376 37.5532 23.0327C38.3591 22.3279 38.9809 21.437 39.3645 20.4374C39.7482 19.4378 39.8821 18.3597 39.7547 17.2967C39.6272 16.2336 39.2423 15.2177 38.6333 14.3371C38.0243 13.4565 37.2096 12.7378 36.2599 12.2434C35.3102 11.7489 34.2542 11.4937 33.1836 11.4999V11.4999Z",
    fill: "#CB2110"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1823 26.375C32.2005 26.3742 31.2212 26.4739 30.2598 26.6725C31.7054 27.4914 32.9187 28.6649 33.7852 30.0825C34.6517 31.5001 35.1428 33.115 35.2123 34.775C35.2045 36.4588 34.6992 38.1026 33.7598 39.5C38.9049 39.3075 42.9999 36.455 42.9999 32.955C42.9999 29.455 38.6074 26.375 33.1823 26.375Z",
    fill: "#804419"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounterManagement);
export default __webpack_public_path__ + "static/media/Counter Management.217ed15178418eaf77c7070fe1ba898b.svg";
export { ForwardRef as ReactComponent };